import moment from 'moment-timezone';

export const getUuid = () => moment().format('x');
